export default __webpack_public_path__ + "static/media/radio-surgery.187488a1.JPG";